import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import TextField from "@mui/material/TextField";
import { useEffect, useState, useRef } from "react";
import TranslatableTextField from "components/TranslatableTextField";
import { Box, Chip, IconButton } from "@mui/material";
import { Close, Edit, Save } from "@mui/icons-material";

export default function ConvertibleInput({
  value,
  readValue,
  multiline,
  fullWidth,
  onChange,
  readOnly,
  inputProps,
  typographyProps,
  onSave,
  waitForSave,
  onCancel,
  includeUpdate,
  containerProps,
  ...rest
}) {
  const [cursor, setCursor] = useState(null);
  const [localValue, setLocalValue] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    setLocalValue(value);
  }, [onCancel]);

  useEffect(() => {
    if (!waitForSave) {
      onChange && onChange({ target: { value: localValue } });
    }
  }, [localValue]);

  useEffect(() => {
    if (onSave) {
      onChange && onChange({ target: { value: localValue } });
    }
  }, [onSave]);

  const handleChange = (e) => {
    setCursor(e.target.selectionStart);
    //if (!waitForSave) onChange && onChange(e);
    setLocalValue(e.target.value);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start",
        position: "relative",
        ...(containerProps?.sx || {}),
      }}
    >
      {!readOnly && (
        <TranslatableTextField
          disableInjectingGlobalStyles
          inputRef={ref}
          {...rest}
          {...inputProps}
          sx={inputProps ? { mt: 1, ...inputProps.sx } : { mt: 1 }}
          fullWidth={fullWidth}
          multiline={multiline}
          values={localValue}
          onChange={handleChange}
        />
      )}
      {readOnly && (
        <MDTypography
          color="inherit"
          variant="inherit"
          {...rest}
          {...typographyProps}
        >
          {typeof localValue == "object" ? readValue : localValue}
        </MDTypography>
      )}

      {readOnly && includeUpdate ? (
        <IconButton size="small" {...includeUpdate.editButtonProps}>
          <Edit />
        </IconButton>
      ) : null}

      {!readOnly && includeUpdate ? (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 3,
            backgroundColor: "white.main",
            display: "flex",
            flexDirection: "row",
            gap: 0.5,
          }}
        >
          <Chip
            size="small"
            variant="contained"
            clickable
            {...(includeUpdate.cancelButtonProps.type == "icon"
              ? {
                  icon: <Close sx={{ marginRight: "-11px !important" }} />,
                  sx: { paddingRight: "0px !important" },
                }
              : { label: "Cancel" })}
            {...includeUpdate.cancelButtonProps}
          />
          <Chip
            size="small"
            variant="contained"
            color="info"
            clickable
            sx={{ color: "white.main" }}
            {...(includeUpdate.cancelButtonProps.type == "icon"
              ? {
                  icon: <Save sx={{ marginRight: "-11px !important" }} />,
                  sx: { paddingRight: "0px !important", color: "white.main" },
                }
              : { label: "Save" })}
            {...includeUpdate.saveButtonProps}
          />
        </Box>
      ) : null}
    </Box>
  );
}
